import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker, Input, InputNumber, Radio, Select } from 'antd';

import DateRangePickerFooter from '../../../../../components/DateRangePickerFooter/DateRangePickerFooter';
import { AddressField } from './AddressField';
import { ServiceField } from './ServiceField';
import { fieldTypes } from '../constants';
import { FieldCallMethodResult, FieldType } from '../propTypes';

export const ExportsFormFieldInner = React.forwardRef(
  (
    {
      form,
      fieldType,

      disabled,
      multiple,

      options,
      optionsLoading,
      optionsSearchable,
      optionsItemMapping,

      ...otherProps
    },
    ref
  ) => {
    const commonProps = {
      ...otherProps,
      ref,
      disabled,
      style: { width: '100%' },
    };
    const commonPropsWithLoading = {
      ...commonProps,
      loading: optionsLoading || false,
    };

    let renderedField = null;
    switch (fieldType) {
      case fieldTypes.int:
        renderedField = multiple ? (
          <Select
            showSearch={optionsSearchable}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.props.children.toLowerCase().includes(input.toLowerCase())
            }
            mode={multiple ? 'multiple' : 'default'}
            allowClear={true}
            {...commonPropsWithLoading}
          >
            {options.map((option) => (
              <Select.Option
                value={option[optionsItemMapping.id]}
                key={option[optionsItemMapping.id]}
              >
                {option[optionsItemMapping.name]}
              </Select.Option>
            ))}
          </Select>
        ) : (
          <InputNumber
            // min={1}
            // max={10}
            {...commonProps}
          />
        );
        break;
      case fieldTypes.string:
        renderedField = (
          <Input.TextArea
            autoSize={{ minRows: 1, maxRows: 5 }}
            {...commonProps}
            style={{ ...commonProps.style, resize: 'none' }}
          />
        );
        break;
      case fieldTypes.bool:
        renderedField = (
          <Radio.Group
            {...commonProps}
            buttonStyle="solid"
            style={{
              ...commonProps.style,
              display: 'flex',
            }}
          >
            {[
              { value: undefined, title: 'Все' },
              { value: true, title: 'Да' },
              { value: false, title: 'Нет' },
            ].map((option) => (
              <Radio.Button
                key={option.title}
                value={option.value}
                style={{
                  flexGrow: 1,
                  textAlign: 'center',
                }}
              >
                {option.title}
              </Radio.Button>
            ))}
          </Radio.Group>
        );
        break;
      // case fieldTypes.dateTime:
      //   renderedField = (
      //     <DatePicker
      //       format={'DD.MM.YYYY HH:mm'}
      //       showTime={{ format: 'HH:mm' }}
      //       {...commonProps}
      //     />
      //     // <DatePicker.MonthPicker />
      //   );
      //   break;
      case fieldTypes.dateRange:
        renderedField = (
          <DatePicker.RangePicker
            format={'DD.MM.YYYY'}
            // showTime={{ format: 'HH:mm' }}
            renderExtraFooter={() => (
              <DateRangePickerFooter
                onRangeClick={({ range }) => {
                  commonProps.onChange(range);
                }}
              />
            )}
            {...commonProps}
          />
        );
        break;
      case fieldTypes.address:
        renderedField = <AddressField {...commonPropsWithLoading} />;
        break;
      /*
        renderedField = (
          <Input.Group compact>
            <Select
              mode="multiple"
              dropdownMatchSelectWidth={false}
              defaultActiveFirstOption={false}
              allowClear={true}
              style={{ width: 220 }}
              placeholder="Улица"
              notFoundContent="нет данных"
              value={selectedStreets}
              onChange={(value) => setSelectedStreets(value)}
              optionLabelProp="label"
              optionFilterProp="searchtext"
            >
              {dspxGetChildrens(streetsQuery?.data || [])}
            </Select>
            <Select
              mode="multiple"
              defaultActiveFirstOption={false}
              allowClear={true}
              style={{ width: 118 }}
              notFoundContent="нет данных"
              placeholder="Дом"
              optionFilterProp="searchtext"
              value={selectedHouses}
              onChange={(value) => setSelectedHouses(value)}
            >
              {dspxGetChildrens(this.props.listAddrBuilding)}
            </Select>
            <Select
              mode="multiple"
              defaultActiveFirstOption={false}
              allowClear={true}
              notFoundContent="нет данных"
              style={{ width: 130 }}
              placeholder="Кв./офис"
              value={this.props.selectedFlats}
              optionFilterProp="searchtext"
              onChange={this.handleAddrFlatChange}
            >
              {dspxGetChildrens(this.props.listAddrFlat, 8)}
            </Select>
          </Input.Group>
        );
        */
      case fieldTypes.service:
        renderedField = <ServiceField {...commonPropsWithLoading} />;
        break;
      default:
        return <div>Ошибка: неожиданный тип поля ({fieldType})</div>;
    }
    return renderedField;
  }
);

ExportsFormFieldInner.propTypes = {
  form: PropTypes.object.isRequired,

  fieldType: FieldType.isRequired,

  disabled: PropTypes.bool,
  multiple: PropTypes.bool,

  options: PropTypes.arrayOf(PropTypes.object.isRequired),
  optionsLoading: PropTypes.bool,
  optionsSearchable: PropTypes.bool,
  optionsItemMapping: FieldCallMethodResult,
};

ExportsFormFieldInner.defaultProps = {
  disabled: false,
  multiple: false,

  options: [],
  optionsLoading: false,
  optionsSearchable: false,
  optionsItemMapping: null,
};
